export const IMAGES = {
  dashboard: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80",
  workspace: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?auto=format&fit=crop&w=1600&q=80",
  building: "https://images.unsplash.com/photo-1552564301-26c5ab5966fa?auto=format&fit=crop&w=1600&q=80",
};

export const PRODUCTS = [
  {
    slug: "system",
    short: "Redoc System",
    label: "System",
    title: ["Två system.", "Ett mål: kvalitet."],
    intro:
      "Redoc är en molntjänst utvecklad för redovisningskonsulter. Välj Redoc med fokus på kvalitetssäkring av uppdragen, eller Redoc AML & KYC med fokus på Penningtvättlagen och kundkännedom.",
    image: IMAGES.workspace,
    systems: [
      {
        name: "Redoc",
        focus: "Kvalitetssäkring av uppdragen",
        text: "Redoc kvalitetssäkrar och ger dig kontroll över byråns kunder och uppdrag. Med färdiga checklistor skapar du enkelt dokumentationen till uppdragen enligt gällande branschstandarder för auktoriserade redovisningskonsulter.",
        features: [
          "Checklista redovisningsuppdrag",
          "Checklista löneuppdrag & AGI",
          "Checklista bokslut & årsredovisning",
          "Checklista momsdeklaration",
          "Checklista inkomstdeklaration & K10",
          "Uppdrags- och momentansvar",
          "Årsplanering",
          "Intern kvalitetskontroll",
        ],
      },
      {
        name: "Redoc AML & KYC",
        focus: "AML och KYC",
        text: "Upprätta kundkännedom (KYC), riskanalyser för tjänster och allmän riskbedömning för byrån. Hjälper redovisningsbyråer att uppfylla kraven i Penningtvättlagen – enkelt, strukturerat och tryggt.",
        features: [
          "Allmän riskbedömning byrån (PTL)",
          "Kundkännedom (KYC)",
          "Årlig genomgång av kundkännedom",
          "Riskanalys ny kund",
          "Riskanalys tjänster",
          "Analys riskhanteringsmetoder",
          "Årlig omprövning av kund",
          "Personal- och utbildningsregister",
        ],
      },
    ],
    highlights: [
      { t: "Molntjänst", d: "Lika lätt att använda på mobilen som på datorn." },
      { t: "Obegränsat", d: "Obegränsat antal kunder, uppdrag, användare och kontor." },
      { t: "Servrar i Sverige", d: "Säker lagring med backup och övervakning." },
      { t: "Anpassningsbart", d: "Rättigheter för användare, avdelningar och kontor." },
    ],
  },
  {
    slug: "aml-kyc",
    short: "Redoc AML & KYC",
    label: "AML & KYC",
    title: ["Kundkännedom och", "riskbedömning –", "på ett ställe."],
    intro:
      "Med Redoc AML & KYC upprättar du kundkännedom, riskanalyser för tjänster och allmän riskbedömning för byrån – en webbaserad tjänst som hjälper redovisningsbyråer att uppfylla kraven i Penningtvättlagen.",
    image: "/amlkyc-screenshot.jpg",
    screenshot: true,
    url: "https://amlkyc.nu/",
    host: "amlkyc.nu",
    linkTestId: "external-link-amlkyc-nu",
    highlights: [
      { t: "Allmän riskbedömning", d: "En strukturerad genomgång av byråns risker enligt PTL." },
      { t: "Kundkännedom (KYC)", d: "Smidiga processer för att identifiera och förstå era kunder." },
      { t: "Löpande kontroll", d: "Trygg förvaring och uppföljning enligt gällande regelverk." },
      { t: "Visa efterlevnad", d: "Enklare när frågor eller granskning kommer." },
    ],
  },
  {
    slug: "recon-ai",
    short: "Recon.ai",
    label: "Recon.ai",
    title: ["Avstämning av", "kontoutdrag", "på sekunder."],
    intro:
      "Ladda upp två kontoutdrag (PDF eller bild). AI identifierar automatiskt alla avvikelser i datum, transaktioner och belopp. Filerna raderas direkt efter analys.",
    image: "/recon-screenshot.jpg",
    screenshot: true,
    noDemo: true,
    url: "https://recon.redoc.se/",
    host: "recon.redoc.se",
    linkTestId: "external-link-recon-redoc",
    highlights: [
      { t: "Automatisk avstämning", d: "AI hittar avvikelserna på sekunder." },
      { t: "PDF eller foto", d: "Inga mallar behövs – ladda upp som du vill." },
      { t: "Export", d: "Tydliga avvikelser med export till Excel, CSV och PDF." },
      { t: "Noll lagring", d: "Sekretess först – filerna raderas direkt." },
    ],
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const SERVICES = [
  { n: "01", t: "Intern kvalitetssäkring", d: "Utveckling och support för er interna kvalitetssäkring – policy för kvalitetssäkring, byrårutiner och förslag på förbättringar." },
  { n: "02", t: "Intern kvalitetskontroll", d: "Vi kontrollerar att era konsulter uppfyller kvalitetskraven för auktoriserade redovisningskonsulter, med rapport över resultat och förbättringsåtgärder." },
  { n: "03", t: "Rådgivning Penningtvättlagen", d: "Konsultationer och rådgivning kring rutiner och dokumentation enligt Penningtvättlagen." },
  { n: "04", t: "Utbildning i Penningtvättlagen", d: "Webbkursen \"Introduktion till Penningtvättlagen för redovisningsbyråer\" – självstudier via vår e-learningportal." },
  { n: "05", t: "Mallar och rutiner", d: "Exempelmallar för riskanalyser och KYC samt mall för byråns rutiner enligt Penningtvättlagen." },
];

export const CONTACT_SUBJECTS = [
  "Boka demo",
  "Redoc – kvalitetssäkring",
  "Redoc AML & KYC",
  "Recon.ai",
  "Intern kvalitetssäkring",
  "Intern kvalitetskontroll",
  "Rådgivning Penningtvättlagen",
  "Utbildning Penningtvättlagen",
  "Mallar och rutiner",
  "Övrigt",
];
